<div class="linked-strategy-outcomes-container">

    <div class="panel-header">
        <h4>Progress Linked to ({{ parentCount }}) Strategy Outcomes</h4>

        <button class="btn-outline bg-primary-300 text-primary btn-icon btn rounded-round ml-2"
            matTooltip="Link Strategy Outcomes"
            [matTooltipShowDelay]="300" [matTooltipHideDelay]="100"
            (click)="openLinkStrategyOutcomesDialog()" tabindex="0">
            <i class="icon-plus-circle2"></i>
            <span class="link-button-text">Link Strategy Outcomes</span>
        </button>
    </div>

    <div class="parent-outcomes-panel">

        @if (isTncGoalsOutcome) {

            @for (parentOutcome of parentOutcomes; track $index) {
                <div class="parent-outcome">

                    <div class="parent-outcome-index">{{ $index + 1 }}</div>

                    <div class="parent-outcome-form">
                        <div class="outcome-id">
                            OC{{ parentOutcome.parentOutcomeId }}
                        </div>
                        <div class="strategy-name">
                            <a target="_blank" href="/portfolio/{{ parentOutcome.parentOutcomeProjectId }}">
                                {{ parentOutcome.parentOutcomeProjectName }}
                            </a>
                        </div>

                        <div class="outcome-statement">
                            <span style="font-weight: bold;">Outcome Statement: </span>
                            <span>{{ parentOutcome.outcomeStatement }}</span>
                        </div>

                        <div class="linkage-notes">
                            <div>Linkage Notes:</div>
                            <textarea placeholder="Enter notes about this linkage here"
                                [(ngModel)]="parentOutcome.linkageNotes"
                                (ngModelChange)="onLinkageNotesChanged()">
                            </textarea>
                        </div>
                    </div>

                    <div class="parent-outcome-action">
                        <a class="action-link" href="javascript:void(0)"
                            (click)="unlinkParentOutcome(parentOutcome)"
                            matTooltip="Unlink" matTooltipShowDelay="500" matTooltipHideDelay="300">
                            <img src="assets/images/icons/unlink_icon.png">
                        </a>
                    </div>

                </div>
            }

        } @else {

            @for (parentCustomOutcome of parentCustomOutcomes; track $index) {
                <div class="parent-outcome">

                    <div class="parent-outcome-index">{{ $index + 1 }}</div>

                    <div class="parent-outcome-form">
                        <div class="outcome-id">
                            CO{{ parentCustomOutcome.parentCustomOutcomeId }}
                        </div>
                        <div class="strategy-name">
                            <a target="_blank" href="/portfolio/{{ parentCustomOutcome.parentCustomOutcomeProjectId }}">
                                {{ parentCustomOutcome.parentCustomOutcomeProjectName }}
                            </a>
                        </div>

                        <div class="outcome-statement">
                            <span style="font-weight: bold;">Outcome Statement: </span>
                            <span>{{ parentCustomOutcome.outcomeStatement }}</span>
                        </div>

                        <div class="linkage-notes">
                            <div>Linkage Notes:</div>
                            <textarea placeholder="Enter notes about this linkage here"
                                [(ngModel)]="parentCustomOutcome.linkageNotes"
                                (ngModelChange)="onLinkageNotesChanged()">
                            </textarea>
                        </div>
                    </div>

                    <div class="parent-outcome-action">
                        <a class="action-link" href="javascript:void(0)"
                            (click)="unlinkParentCustomOutcome(parentCustomOutcome)"
                            matTooltip="Unlink" matTooltipShowDelay="500" matTooltipHideDelay="300">
                            <img src="assets/images/icons/unlink_icon.png">
                        </a>
                    </div>

                </div>
            }

        }

        @if (parentCount === 0) {
            <div class="d-block alert alert-info alert-styled-left shadow-0" style="width: 100%;">
                No strategy outcomes are linked yet.
            </div>
        }

    </div>

</div>
